import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import WOW from 'wowjs';
import { Card, CardContent } from '../components/Card';
import { Carousel } from 'react-responsive-carousel';
import 'animate.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Helmet } from "react-helmet-async";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import bannerone from '../assets/img/banner/3.png';
import bannertwo from '../assets/img/banner/2.png';
import bannerthree from '../assets/img/banner/1.png';
import bannerfour from '../assets/img/banner/4.png';
import bannerfive from '../assets/img/banner/5.png';
import aboutone from '../assets/img/about/1.png';
import abouttwo from '../assets/img/about/2.png';
import iconsone from '../assets/img/icons/1.png';
import iconstwo from '../assets/img/icons/2.png';
import iconsthree from '../assets/img/icons/3.png';
import iconsfour from '../assets/img/icons/4.png';
import iconsfive from '../assets/img/icons/5.png';
import iconssix from '../assets/img/icons/6.png';
import iconsseven from '../assets/img/icons/7.png';
import iconseight from '../assets/img/icons/8.png';
import iconsnine from '../assets/img/icons/9.png';
import serviceone from '../assets/img/service-1.jpg';
import servicetwo from '../assets/img/service-2.jpg';
import servicethree from '../assets/img/service-3.jpg';
import servicefour from '../assets/img/service-4.jpg';
import servicefive from '../assets/img/service-5.jpg';
import servicesix from '../assets/img/service-6.jpg';
import noproduct from '../assets/img/icons/no-product.jpg';
const Home = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    new WOW.WOW().init(); // Initialize WOW.js animations
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await fetch("https://jiimpex.com/new_project/ji-impex/add-to-home.php");
      const data = await response.json();
      console.log("API Response:", data);

      if (data && data.products) {
        setServices(data.products);
      } else {
        setServices([]); // Handle empty case
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };
  const [products, setProducts] = useState([]);

  const [formData, setFormData] = useState({
    gname: "",
    gmail: "",
    cname: "",
    cage: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("");

  // Handle input change dynamically
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://jiimpex.com/new_project/ji-impex/send_email.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      setStatusMessage(result.message);
    } catch (error) {
      console.error("Error:", error);
      setStatusMessage("Something went wrong. Try again later.");
    }
  };

  useEffect(() => {
    axios.get('https://jiimpex.com/new_project/ji-impex/get-home-products.php')
      .then(response => {
        console.log(response)
        setProducts(response.data);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }, []);

  return (
    <>
    {/* Page Title */}
    <Helmet>
        <title>Home || JI IMPEX</title>
      </Helmet>
    <div>
      {/* <Carousel autoPlay infiniteLoop showThumbs={false}>
        <div>
          <img src="/img/banner/5.png" alt="Banner 1" />
          <p className="legend">Ship Machinery & Spares Supplier</p>
        </div>
        <div>
          <img src="/img/banner/1.png" alt="Banner 2" />
          <p className="legend">Ship Spare Parts Supplier In India</p>
        </div>
        <div>
          <img src="/img/banner/2.png" alt="Banner 3" />
          <p className="legend">Miscellaneous Marine Items</p>
        </div>
      </Carousel>*/}

      <div class="container-fluid p-0 mb-5 wow fadeIn" data-wow-delay="0.1s">
        <div id="header-carousel" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="w-100" src={bannerone} alt="Image" />
              <div class="carousel-caption">
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-lg-8">
                      <h5 class="text-light text-uppercase mb-3 animated slideInDown">Welcome To J.I. Impex</h5>
                      <h1 class="display-3 text-light mb-3 animated slideInDown">Ship Machinery & Spares Supplier</h1>
                      <p class="display-5 text-light mb-3 animated slideInDown">Quality Equipment From The World Top Brands</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <img class="w-100" src={bannertwo} alt="Image" />
              <div class="carousel-caption">
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-lg-8">
                      <h5 class="text-light text-uppercase mb-3 animated slideInDown">Welcome To J.I. Impex</h5>
                      <h1 class="display-3 text-light mb-3 animated slideInDown">Ship Spare Parts Supplier In India</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <img class="w-100" src={bannerthree} alt="Image" />
              <div class="carousel-caption background-color">
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-lg-8">
                      <h5 class="text-light text-uppercase mb-3 animated slideInDown">Welcome To J.I. Impex</h5>
                      <h1 class="display-3 text-light mb-3 animated slideInDown">Miscellaneous Marine Items</h1>
                      <p class="display-5 text-light mb-3 animated slideInDown">Stockist For Miscellaneous Marine Items.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <img class="w-100" src={bannerfour} alt="Image" />
              <div class="carousel-caption t-shadow">
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-lg-8">
                      <h5 class="text-dark text-uppercase mb-3 animated slideInDown">Welcome To J.I. Impex</h5>
                      <h1 class="display-3 text-dark mb-3 animated slideInDown">Oil Filters</h1>
                      <p class="display-5 text-dark mb-3 animated slideInDown">ALFA LAVAL, MITSUBISHI & WESTFALIA</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <img class="w-100" src={bannerfive} alt="Image" />
              <div class="carousel-caption">
                <div class="container">
                  <div class="row=">
                    <div class="col-12 col-lg-8">
                      <h5 class="text-light text-uppercase mb-3 animated slideInDown">Welcome To J.I. Impex</h5>
                      <h1 class="display-3 text-light mb-3 animated slideInDown">Exclusive Deals on PCBs</h1>
                      <p class="display-5 text-light mb-3 animated slideInDown">We are stockpile of NEW, PRE OWNED AND OBSOLETE industrial & marine automation equipment</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* <!-- About Start --> */}
      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="position-relative overflow-hidden ps-5 pt-5 h-100" style={{ minHeight: '400px' }}>
                <img class="position-absolute w-100 h-100" src={aboutone} alt="" style={{ objectFit: 'cover' }} />
                <div class="position-absolute top-0 start-0 bg-white pe-3 pb-3" style={{ width: '200px', height: '200px' }}>
                  <div class="d-flex flex-column justify-content-center text-center bg-primary h-100 p-3">
                    <h1 class="text-white">30</h1>
                    <h2 class="text-white">Years</h2>
                    <h5 class="text-white mb-0">Experience</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="h-100">
                <div class="border-start border-5 border-primary ps-4 mb-5">
                  <h6 class="text-body text-uppercase mb-2">About Us</h6>
                  <h1 class="display-6 mb-0">Marine Spare Parts, Equipments, and Industrial Automation all at one place.</h1>
                </div>
                <p>J.I.IMPEX is a leading supplier of new, used and refurbished ship spares and machinery.If you are looking for quality marine equipment, then we can provide you the best ship machinery.</p>
                <p class="mb-4">At J.I.IMPEX, we specialize in sourcing new surplus and second-hand machinery and equipment from Asia’s largest Ship Recycling Yard – Alang (India). Our rigorous inspection and refurbishing procedures ensure that all our products meet the highest quality standards before being sold to traders and end-users.</p>
                <div class="border-top mt-4 pt-4">
                  <div class="row g-4">
                    <div class="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.1s">
                      {/* <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> */}
                      <FontAwesomeIcon icon={faCheck} className="text-primary" style={{ fontSize: '2em', marginRight: '12px' }} />
                      <h6 class="mb-0">Reasonable & Competitive Price</h6>
                    </div>
                    <div class="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.3s">
                      {/* <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> */}
                      <FontAwesomeIcon icon={faCheck} className="text-primary" style={{ fontSize: '2em', marginRight: '12px' }} />
                      <h6 class="mb-0">Quick Communication</h6>
                    </div>
                    <div class="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.5s">
                      {/* <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> */}
                      <FontAwesomeIcon icon={faCheck} className="text-primary" style={{ fontSize: '2em', marginRight: '12px' }} />
                      <h6 class="mb-0">Fast Delivery</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}

      {/* <!-- Features Start --> */}
      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="border-start border-5 border-primary ps-4 mb-5">
                <h6 class="text-body text-uppercase mb-2">Why Choose Us!</h6>
                <h1 class="display-6 mb-0">We are J.I.Impex</h1>
              </div>
              <p class="mb-5" style={{ textTransform: 'capitalize' }}>We are a team of maritime professional including engineers and sales experts, who work 24 * 7 * 365, to make sure our client ships keep working. We supply spares with working guarantee and after sale support. </p>
              <div class="row gy-5 gx-4">
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconsone} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>ADVANCED TECHNOLOGY</h6>
                  </div>
                  <span>Our workshop is equipped with advance technology to repair and refurbish major spares , with the lest required time.</span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconstwo} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>DELIVERY ON TIME</h6>
                  </div>
                  <span>Time is the most valuable asset in Marine industry. We maintain a track record of supplying our spares within 24 hrs of receiving order confirmation.</span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconsthree} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>CERTIFIED PRODUCTS</h6>
                  </div>
                  <span>Our products is 100% genuine and well certified by our experienced experts, and we delivered products with best rates.</span>
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                  <div class="d-flex align-items-center mb-3">
                    {/* <!-- <i class="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i> --> */}
                    <img class="img-fluid" src={iconsfour} alt="" />
                    <h6 class="mb-0" style={{ marginLeft: '12px' }}>BEST SERVICES</h6>
                  </div>
                  <span>We Provide Services like Class Survey, MPI & Hardness Test, Sandblasting, Repainting and other Services.</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="position-relative overflow-hidden ps-5 pt-5 h-100" style={{ minHeight: '400px' }}>
                <img class="position-absolute w-100 h-100" src={abouttwo} alt="" style={{ objectFit: 'cover' }} />
                <div class="position-absolute top-0 start-0 bg-white pe-3 pb-3" style={{ width: '200px', height: '200px' }}>
                  <div class="d-flex flex-column justify-content-center text-center bg-primary h-100 p-3">
                    <h1 class="text-white">30</h1>
                    <h2 class="text-white">Years</h2>
                    <h5 class="text-white mb-0">Experience</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Features End --> */}

      {/* <section className="py-5">
        <h2 className="text-center text-2xl font-bold mb-5">Our Products</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {products.map(product => (
            <Card key={product.id} className="overflow-hidden">
              <img className="w-full h-48 object-cover" src={`https://jiimpex.com/new_project/ji-impex/admin/uploads/products/${product.product_image}`} alt={product.name} />
              <CardContent>
                <h5 className="text-xl font-semibold mb-2">{product.name}</h5>
                <p>{product.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section> */}

       {/* <!-- Service Start --> */}
       <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-end mb-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="border-start border-5 border-primary ps-4">
                                {/* <h6 className="text-body text-uppercase mb-2">Our Products</h6> */}
                                <h1 className="display-6 mb-0">Our Products</h1>
                            </div>
                        </div>
                        {/* <div className="col-lg-6 text-lg-end wow fadeInUp" data-wow-delay="0.3s">
                            <a className="btn btn-primary py-3 px-5" href="">More Services</a>
                        </div> */}
                    </div>
                    <div className="row g-4 justify-content-center">
                        {services.length > 0 ? (
                            services.map((service, index) => (
                                <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`} key={service.id}>
                                    <div className="service-item bg-light overflow-hidden h-100">
                                        <img className="img-fluid" src={service.product_image} alt={service.name} />
                                        <div className="service-text position-relative text-center h-100 p-4">
                                            <h5 className="mb-3">{service.name}</h5>
                                            <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
                                            {/* <a className="small" href="#">READ MORE<i className="fa fa-arrow-right ms-3"></i></a> */}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                          <div className="text-center py-5">
                          <img src={noproduct} alt="No Products" className="img-fluid" style={{ maxWidth: "200px" }} />
                          <h4 className="mt-3 text-muted">No Products Available</h4>
                          <p className="text-muted">We're sorry, but there are no products available at the moment.</p>
                          {/* <button className="btn btn-primary" onClick={() => window.location.reload()}>Refresh</button> */}
                      </div>
                        )}
                    </div>
                </div>
            </div>
            {/* <!-- Service End --> */}

      {/* <!-- Appointment Start --> */}
      <div class="container-fluid appointments my-5 py-5 wow fadeIn" data-wow-delay="0.1s">
        <div class="container py-5">
          <div class="row g-5" style={{ alignItems: 'center' }} >
            <div class="col-lg-5 col-md-6 wow fadeIn" data-wow-delay="0.3s">
              <div class="border-start border-5 border-primary ps-4 mb-5">
                <h6 class="text-white text-uppercase mb-2">Get In Touch</h6>
                <h2 class="text-white mb-0">The Importance of Quality Marine Spare Parts : Choose J.I. Impex as Your Supplier</h2>
              </div>
              <p class="text-white mb-0">The Importance of Quality Marine Spare Parts: Choose J.I.impex  as Your Supplier This is because operation requires intensity, hence marine vessels have to have very powerful, reliable components to complete the work in the best flow. Safety and efficiency in the process of maritime operation require quite a lot of quality spare parts. J.I.impex offers some of the best levels of Marine spare parts Suppliers coming from the reputable producers in its extensive portfolio which was designed according to the requirements of the industry.<br /><br />Any requirement you have  feel free to contact us</p>
            </div>
            <div class="col-lg-7 col-md-6 wow fadeIn" data-wow-delay="0.5s">
              <form onSubmit={handleSubmit} method='POST'>
                <div className="row g-3">
                  <div className="col-sm-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control bg-dark border-0 text-white"
                        name="gname"
                        placeholder="Guardian Name"
                        value={formData.gname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="gname">Your Name</label>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control bg-dark border-0 text-white"
                        name="gmail"
                        placeholder="Guardian Email"
                        value={formData.gmail}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="gmail">Your Email</label>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control bg-dark border-0 text-white"
                        name="cname"
                        placeholder="Child Name"
                        value={formData.cname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="cname">Your Mobile</label>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control bg-dark border-0 text-white"
                        name="cage"
                        placeholder="Child Age"
                        value={formData.cage}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="cage">Subject</label>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control bg-dark border-0 text-white"
                        placeholder="Leave a message here"
                        name="message"
                        style={{ height: "100px" }}
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>

                  <div className="col-12">
                    <button className="btn btn-primary w-100 py-3" type="submit">
                      Send Mail
                    </button>
                  </div>
                </div>

                {statusMessage && <p className="mt-3 text-white">{statusMessage}</p>}
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Appointment End --> */}

      {/* <!-- Counter Start --> */}
      <div class="container-fluid">
        <div class="container">
          <div class="row g-4 counter-area-div justify-content-between" >
            <div class="col-lg-6 col-xl-2 counter text-center">
              <img class="img-fluid" src={iconsfive} alt="" />
              <h2 class="count-title-choose">Best prices & offers</h2>
              <p class="count-text ">Best Competitive Rates</p>
            </div>

            <div class="col-lg-6 col-xl-2 counter text-center">
              <img class="img-fluid" src={iconssix} alt="" />
              <h2 class="count-title-choose">Delivery</h2>
              <p class="count-text ">Express World Wide Shipping Via DHL or Fedex</p>
            </div>

            <div class="col-lg-6 col-xl-2 counter text-center">
              <img class="img-fluid" src={iconsseven} alt="" />
              <h2 class="count-title-choose">Flash Deals</h2>
              <p class="count-text ">For New Sign-Ups</p>
            </div>

            <div class="col-lg-6 col-xl-2 counter text-center">
              <img class="img-fluid" src={iconseight} alt="" />
              <h2 class="count-title-choose">Customer Support</h2>
              <p class="count-text ">24/7 at Your Service</p>
            </div>

            <div class="col-lg-6 col-xl-2 counter text-center">
              <img class="img-fluid" src={iconsnine} alt="" />
              <h2 class="count-title-choose">Easy returns</h2>
              <p class="count-text ">Within 30 Days</p>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Counter End --> */}
    </div>
    </>
  );
};

export default Home;
